import React from 'react';

export default function TrustpilotIcon({ className = "w-4 h-4 shrink-0", ...props }) {
  return (
    <svg
      viewBox="0 0 126 126"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M125.996 48.0674L77.8926 48.0674L63.0039 2.24707L48.1152 48.0674L0.0117188 48.0674L38.9414 76.3535L24.082 122.174L63.0039 93.8877L101.926 122.174L87.0664 76.3535L125.996 48.0674Z"
        fill="#00B67A"
      />
      <path
        d="M87.0664 76.3535L101.926 122.174L63.0039 93.8877L87.0664 76.3535Z"
        fill="#005128"
      />
    </svg>
  );
}
